var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { defaultProps } from './defaults';
// import { ReactAnchorProps, AnchorComponent } from '@feb-team/props-spec'
import Affix from '../Affix';
import AnchorLink from './AnchorLink';
import { DivTag } from '../../Utils/AtomicTag';
import qs from '../BackTop/qs';
import { throttle } from '@feb-team/data-logic';
import { toArray } from '../../Utils/react';
var Anchor = /** @class */ (function (_super) {
    __extends(Anchor, _super);
    function Anchor(props) {
        var _this = _super.call(this, props) || this;
        _this.changeActiveLink = function (href) {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(href);
            }
            _this.setState({
                activeLink: href,
            });
        };
        /**
         * 切换滚动为真实滚动还是自动滚动
         */
        _this.changeScrollStatus = function (antoScroll) {
            _this.setState({
                antoScroll: antoScroll,
            });
        };
        _this.isActive = function (element) {
            if (!element)
                return;
            var height = window.innerHeight;
            try {
                var floorRect = element.getBoundingClientRect();
                return floorRect.top <= 0 && floorRect.bottom > 0;
                // || (floorRect.top < height && floorRect.bottom > height)
            }
            catch (error) {
                console.warn('不支持getBoundingClientRect方法');
            }
        };
        _this.handleScroll = function () {
            var _a = _this.state, hrefs = _a.hrefs, antoScroll = _a.antoScroll, activeLink = _a.activeLink;
            if (antoScroll)
                return;
            hrefs &&
                hrefs.forEach(function (href) {
                    var element = qs("#" + href);
                    if (_this.isActive(element)) {
                        if (href !== activeLink) {
                            _this.changeActiveLink(href);
                        }
                    }
                });
        };
        var hrefs = [];
        toArray(_this.props.children).forEach(function (link) { return hrefs.push(link.props.href); });
        _this.state = {
            hrefs: hrefs,
            activeLink: hrefs[0],
            antoScroll: false,
        };
        _this.handleScroll = throttle(_this.handleScroll, 50);
        window.addEventListener('scroll', _this.handleScroll);
        return _this;
    }
    Anchor.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleScroll);
    };
    Anchor.prototype.renderAnchorLink = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onClick = _a.onClick, type = _a.type;
        var atomicContainer = ['flex'];
        if (type === 'horizontal') {
            atomicContainer.push('flex-row');
        }
        if (type === 'vertical') {
            atomicContainer.push('flex-col');
        }
        return (React.createElement(DivTag, { className: className, atomics: atomicContainer }, React.Children.map(this.props.children, function (Link) {
            return React.cloneElement(Link, {
                activeLink: _this.state.activeLink,
                onClick: onClick,
                changeActiveLink: _this.changeActiveLink,
                changeScrollStatus: _this.changeScrollStatus,
            });
        })));
    };
    Anchor.prototype.renderAnchorWrap = function () {
        var _a = this.props, affix = _a.affix, rest = __rest(_a, ["affix"]);
        if (affix) {
            return React.createElement(Affix, __assign({}, rest), this.renderAnchorLink());
        }
        else {
            return this.renderAnchorLink();
        }
    };
    Anchor.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderAnchorWrap());
    };
    Anchor.NAME = 'anchor';
    Anchor.displayName = 'Anchor';
    Anchor.defaultProps = defaultProps;
    Anchor.Link = AnchorLink;
    return Anchor;
}(React.PureComponent));
export default Anchor;
